import { type RichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/richiestaDTO.ts';
import { useCardinalityConstraintContext } from '@framework/common-web/schema/submissions/cardinality/CardinalityConstraintContext.tsx';
import {
  type IOnAfterSave,
  type IOnBeforeSave,
} from '@framework/frontoffice-submission/module/form/useSubmitModuleForm.ts';
import { useCallback } from 'react';

/**
 * Ritorna due funzioni da utilizzare prima e dopo il salvataggio di un modulo.
 * Permettono di eseguire azioni personalizzate prima e dopo il salvataggio.
 */
export function useModuleSaverPrehooks() {
  const { setConstraints } = useCardinalityConstraintContext();

  // Con l'introduzione del salvataggio atomico questa funzione non fa più nulla,
  // ma possiamo lasciarla per eventuali azioni future da eseguire prima del salvataggio.
  const onBeforeSave: IOnBeforeSave = useCallback(async () => {}, []);

  const onAfterSave: IOnAfterSave = useCallback(
    async (savedSubmission: RichiestaDTO | undefined | null) => {
      if (!savedSubmission) return;

      // Se al salvataggio risulta che sono stati violati dei vincoli di cardinalità,
      // li salviamo nel contesto così da poterli visualizzare.
      if (
        savedSubmission.violazioneVincoloCardinalita &&
        savedSubmission.violazioneVincoloCardinalita.length > 0
      ) {
        setConstraints(savedSubmission.violazioneVincoloCardinalita);
      } else {
        // Altrimenti, se non ci sono vincoli di cardinalità, li resettiamo
        setConstraints([]);
      }
    },
    [setConstraints],
  );

  return { onBeforeSave, onAfterSave };
}
